import { render } from "./ImageHandler.vue?vue&type=template&id=3c160049"
import script from "./ImageHandler.vue?vue&type=script&lang=js"
export * from "./ImageHandler.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__